/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFilePptShortcut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v10H4zm11 3.414V7h1.586zM18 20v-1h2v3H8v-2z" />
        <path d="M9.77 17v-4.87h1.741c.599 0 1.05.138 1.354.415.308.277.462.687.462 1.232 0 .54-.154.952-.462 1.233-.304.277-.755.416-1.354.416h-.703V17zm1.527-4.02h-.49v1.595h.49c.357 0 .61-.06.757-.181.152-.125.228-.33.228-.617 0-.29-.076-.495-.228-.616-.147-.12-.4-.18-.757-.18zM13.97 17v-4.87h1.742c.598 0 1.05.138 1.353.415.308.277.463.687.463 1.232 0 .54-.154.952-.463 1.233-.304.277-.755.416-1.353.416h-.704V17zm1.528-4.02h-.49v1.595h.49c.357 0 .61-.06.757-.181.151-.125.227-.33.227-.617 0-.29-.076-.495-.227-.616-.148-.12-.4-.18-.757-.18zM19.29 17v-3.986h-1.44v-.885h3.927v.885h-1.44V17zm-16.816.474L1 16h5v5l-1.653-1.653c-1.27.777-1.936 1.982.672 3.653 0 0-4.56-.436-3.298-4.29 0 0 .18-.576.753-1.236z" />
      </g>
    </g>
  </Icon>
);
export { SvgFilePptShortcut as FilePptShortcut };
